import type { ReactNode } from "react";
import { PublicToc, type PublicTocItem } from "@/components/PublicToc";

type PublicDocLayoutProps = {
  toc: PublicTocItem[];
  children: ReactNode;
};

export function PublicDocLayout({ toc, children }: PublicDocLayoutProps) {
  return (
    <div className="public-doc-layout">
      {toc.length > 0 ? <PublicToc items={toc} /> : null}
      <div className="public-doc-body">{children}</div>
    </div>
  );
}

export function PublicSectionAnchor({ sectionId }: { sectionId: string }) {
  return (
    <a href={`#${sectionId}`} className="public-section-anchor" aria-label="Link to this section">
      #
    </a>
  );
}
